import { CompanyLocationDto } from '../api/dto/user.dto'
import { CompanyContactData } from '../models/user.model'

const fromCompanyDtoToCompanyModelTransformer = (dto: CompanyLocationDto): CompanyContactData => {
  return { ...dto }
}

export default fromCompanyDtoToCompanyModelTransformer
